import React from 'react';

const NotFound = () => {
    return (
        <div>
            <img className="img-fluid" src="https://miro.medium.com/max/2000/1*cLQUX8jM2bMdwMcV2yXWYA.jpeg" alt="" />
        </div>
    );
};

export default NotFound;